export const TEXTS = {
    LOGIN: "Login",
    FULL_NAME: "Full Name",
    EMAIL: "Email",
    PASSWORD: "Password",
    REGISTER: "Register",
    FORGOT_PASSWORD: "Forgot Password",
    BY_SIGNING: "By signing in you agree to our",
    TERMS: "Terms and Conditions.",
    REGISTER_FACEBOOK: "Register with Facebook",
    REGISTER_GOOGLE: "Register with Google",
    NEW_USER: "New User?",
    CREATE_ACCOUNT: "Create account",
    ALREADY_HAVE_ACCOUNT: "Already have an account? ",
    LOGIN_NOW: "Login now",
    OR: "Or",
    EMAIL_REQUIRED: "Email must be filled out",
    EMAIL_INVALID: "Enter valid email address",
    PASSWORD_REQUIRED: "Password cannot be blank.",
    INVALID_LOGIN: "Invalid login or password.",
    NAME_REQUIRED: "Please enter Name.",
    NAME_INVALID: "Invalid characters in name field",
    RESET_PASSWORD: "Reset password",
    OOPS: "Something went wrong!!!",
    LOGIN_USING_EMAIL: "Please login using email",
};

export const FB_IMAGE = "/pub/static/frontend/Nykaa/theme001/en_US/images/faceboossk.svg";
export const G_PLUS_IMAGE = "/pub/static/frontend/Nykaa/theme001/en_US/images/sg+.svg";

export enum FORM_STATE {
    LOGIN,
    SIGN_UP,
    FORGOT_PASSWORD,
}

export const LOGIN_ERROR_COOKIE = "loginError";
export const VALID_LOGIN_ERROR = "email";

export const QUERY_STRING_AUTH_INITIATER = "ptype";
export const QUERY_STRING_AUTH_VALUE = "auth";

export const FORM_TITLE = {
    [FORM_STATE.LOGIN]: TEXTS.LOGIN,
    [FORM_STATE.SIGN_UP]: TEXTS.CREATE_ACCOUNT,
    [FORM_STATE.FORGOT_PASSWORD]: TEXTS.FORGOT_PASSWORD,
};
